import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
export default function useCheckoutQuote(payload) {
    const { accessToken } = useTokenStore();
    const quote = useQuery(["checkout-quote", payload], async () => {
        const api = await InitApi({ accessToken });
        const response = await api.post("/checkout/quotes", payload);
        return response.data.data;
    }, { enabled: Boolean(accessToken), staleTime: 30000, retry: 0, refetchOnWindowFocus: false });
    const accept = async () => {
        if (!quote.data) throw new Error("Wait for the checkout quote before paying.");
        const api = await InitApi({ accessToken });
        await api.post(`/checkout/quotes/${quote.data.quote_id}/accept`);
        return quote.data;
    };
    return { ...quote, accept };
}
